import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

const KEY = 'pendingRedirect'
const AUTH_PATHS = ['/', '/login', '/register', '/add-profile']
const ROLE_HOME = {
  Admin: '/admin',
  Verifier: '/verifier',
  Student: '/student',
  Teacher: '/teacher',
}

export const savePendingRedirect = (path = window.location.pathname + window.location.search) => {
  const pathname = (path || '').split('?')[0]
  if (!pathname || AUTH_PATHS.includes(pathname)) return
  window.sessionStorage.setItem(KEY, path.startsWith('/') ? path : `/${path}`)
}

export const getPendingRedirect = () => window.sessionStorage.getItem(KEY)

export const clearPendingRedirect = () => window.sessionStorage.removeItem(KEY)

export const getRoleHomePath = (profileType) => ROLE_HOME[profileType] || '/login'

export default function usePendingRedirect() {
  const navigate = useNavigate()

  const goAfterLogin = useCallback(
    (profileType, { consume = false, replace = false } = {}) => {
      const pending = getPendingRedirect()
      if (pending) {
        if (consume) clearPendingRedirect()
        navigate(pending, { replace })
        return
      }
      navigate(getRoleHomePath(profileType), { replace })
    },
    [navigate],
  )

  return { savePendingRedirect, clearPendingRedirect, goAfterLogin }
}
